import FormFieldProps from "features/shared/forms/dynamicForm/models/FormFieldProps";
import SelectBoxField from "./SelectBoxField";
import TextBoxField from "./TextBoxField";
import TextAreaField from "./TextAreaField";
import FileBoxField from "./FileBoxField";
import ContractSelectField from "./ContractSelectField";
import ContractualAccountSelectField from "./ContractualAccountSelectField";
import { FormFieldType } from "./FormFieldType";
import FileBoxMultipleField from "./FileBoxMultipleField";
import DatePickerField from "./DatePickerField";
import SelectField from "./SelectField";
import SelectMultipleField from "./SelectMultipleField";
import RadioBoxBoolField from "./RadioBoxBoolField";

type Field = (props: FormFieldProps) => JSX.Element;
type ComponentMap = Record<FormFieldType, Field>; 

export const FormFieldsMap: ComponentMap  = {
  "TextBox": TextBoxField,
  "SelectBox": SelectBoxField,
  "TextArea": TextAreaField,
  "FileBox": FileBoxField,
  "ContractSelect": ContractSelectField,
  "ContractualAccountSelect": ContractualAccountSelectField,
  "FileBoxMultiple": FileBoxMultipleField,
  "DatePicker": DatePickerField,
  "Select": SelectField,
  "SelectMultiple": SelectMultipleField,
  "RadioBoxBool": RadioBoxBoolField
}